import * as BookingType from './bookingType';

export default {
  ...BookingType,
  DETAILS: 'DETAILS',
  BOOK: 'BOOK',
  SHARE: 'SHARE',
};
